module.exports = __webpack_public_path__ + "img/golia-powered-by.c492634a.png";